export default __webpack_public_path__ + "static/media/wealthman.0ceacf1c.jpg";